import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { selectXidroLoaded, selectXidroState } from '../../_selectors/xidroDevices.selectors';
import { FlowMetersModel, PressureSensorsModel, PumpSystemsModel, ZoneModel } from '../../_models';
import { loadXidroDevices } from '../../_actions/xidroDevices';
import { AppState } from '../../_reducers';

@Injectable({
  providedIn: 'root',
})
export class XapiXidroService {
  //! xidro doesn't have a testing env at the moment
  private apiBaseUrl = `${environment.apiGatewayUrl.includes('-dev.') ? environment.apiGatewayUrl.replace('-dev', '') : environment.apiGatewayUrl}xidro`;

  loaded$ = this.store.select(selectXidroLoaded);
  xidroState$ = this.store.select(selectXidroState);

  constructor(
    private store: Store<AppState>,
    private http: HttpClient
  ) {}

  loadXidroDevices() {
    this.loaded$.subscribe((loaded) => {
      if (!loaded) {
        this.store.dispatch(loadXidroDevices());
      }
    });
  }

  // API Calls
  getPumpSystems(): Observable<PumpSystemsModel[]> {
    return this.http.get<PumpSystemsModel[]>(`${this.apiBaseUrl}/v2/pump_systems`);
  }

  getPressureSensors(): Observable<PressureSensorsModel[]> {
    return this.http.get<PressureSensorsModel[]>(`${this.apiBaseUrl}/v2/pressure_sensors`);
  }

  getZones(): Observable<ZoneModel[]> {
    return this.http.get<ZoneModel[]>(`${this.apiBaseUrl}/v2/zones`);
  }

  getFlowMeters(): Observable<FlowMetersModel[]> {
    return this.http.get<FlowMetersModel[]>(`${this.apiBaseUrl}/v1/flow_meters`);
  }
}
